"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navDropdownStyles = exports.dropdownPosition = exports.navWrapperTheme = exports.navAvatarHoverColor = exports.navPlainTextColor = exports.navItemHoverBgColor = exports.navActiveItemColor = exports.navItemHoverColor = exports.navItemColor = exports.navAccentColor = exports.navShadowColor = exports.navBarColor = exports.navIconSize = exports.navHeight = exports.switcherHeight = exports.mobileItemHoverColor = exports.mobileItemColor = exports.mobileNavHeight = void 0;

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _theme = require("../styles/theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Nav (mobile) settings


var mobileNavHeight = '30px';
exports.mobileNavHeight = mobileNavHeight;
var mobileItemColor = _theme.colors.grey.primary;
exports.mobileItemColor = mobileItemColor;
var mobileItemHoverColor = _theme.colors.blue.primary; // Account switcher settings

exports.mobileItemHoverColor = mobileItemHoverColor;
var switcherHeight = '34px'; // Nav settings

exports.switcherHeight = switcherHeight;
var navHeight = '50px';
exports.navHeight = navHeight;
var navIconSize = _theme.fonts.sans.size.xlarge;
exports.navIconSize = navIconSize;
var navBarColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.grey.secondary,
  v1: _theme.colors.blue.primary
});
exports.navBarColor = navBarColor;
var navShadowColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.grey.lightest,
  v1: _theme.colors.blue.secondaryLight
});
exports.navShadowColor = navShadowColor;
var navAccentColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.grey.secondaryDark,
  v1: _theme.colors.blue.primaryDark
});
exports.navAccentColor = navAccentColor;
var navItemColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.grey.primary,
  v1: _theme.colors.blue.secondary
});
exports.navItemColor = navItemColor;
var navItemHoverColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.blue.primaryLight,
  v1: _theme.colors.white
});
exports.navItemHoverColor = navItemHoverColor;
var navActiveItemColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.blue.primaryDark,
  v1: _theme.colors.white
});
exports.navActiveItemColor = navActiveItemColor;
var navItemHoverBgColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.grey.secondaryLight,
  v1: _theme.colors.blue.primaryDark
});
exports.navItemHoverBgColor = navItemHoverBgColor;
var navPlainTextColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.grey.altDark,
  v1: _theme.colors.blue.secondaryDark
});
exports.navPlainTextColor = navPlainTextColor;
var navAvatarHoverColor = (0, _styledTheming.default)('mode', {
  default: _theme.colors.blue.primaryLight,
  v1: _theme.colors.grey.altDark
}); // bc v1 things

exports.navAvatarHoverColor = navAvatarHoverColor;
var navWrapperTheme = (0, _styledTheming.default)('mode', {
  default: "\n    box-shadow: 0 1px 2px 2px ".concat(navShadowColor, "\n  ")
}); // Dropdown styling

exports.navWrapperTheme = navWrapperTheme;
var dropdownPosition = {
  left: "\n    position: relative;\n    ul {\n      right: 0px;\n      left: auto;\n      border-radius: 2px 0 2px 2px;\n      @media screen and (max-width: 1000px) {\n        right: 0;\n      };\n    }\n  "
};
exports.dropdownPosition = dropdownPosition;
var navDropdownStyles = "\n  padding-top: 0;\n  position: static;\n  > ul {\n    margin-top: -1px;\n    min-width: auto;\n  }\n  &:hover::after {\n    color: ".concat(mobileItemHoverColor, ";\n  }\n  &::after {\n    width: 20px;\n    font-size: 16px;\n  }\n  @media screen and (max-width: 1000px) {\n    position: relative;\n    max-height: none;\n    background: none;\n    border-radius: 0;\n    width: 100%;\n    padding-top: 0;\n    > ul {\n      position: relative;\n      border: 0;\n      padding: 0 10px;\n      box-shadow: none;\n      top: auto;\n      right: auto;\n      &::before {\n        display: none;\n      }\n      li {\n        margin: 2px 0;\n        a {\n          font-size: ").concat(_theme.fonts.sans.size.small, ";\n          padding: 0 10px;\n          text-transform: none;\n          &:hover {\n            background: none;\n          }\n        }\n      }\n    }\n}\n");
exports.navDropdownStyles = navDropdownStyles;